import {TFunction} from 'i18next'

/**
 * React-hooks-forms validator for use in a `register` call.  Preconfigured for `min` value validation
 */
export const minValidator = (t: TFunction, value: number) => ({
  min: {
    value,
    message: t('error.minValue', {value})
  }
})

export const requiredValidator = (t: TFunction) => ({
  required: t('error.required')
})
